import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PaperBags = () => <ProductDetailPage {...getProductPageConfig('paperBags')} />;

export default PaperBags;
